import { combineReducers } from 'redux'

import auth from '@/containers/Login/AuthSlice'
import pageConfiguration from '@/store/PageConfiguration/PageConfigurationSlice'
import usersManagement from '@/containers/UsersManagement/UsersManagementSlice'
import servicesStatus from '@/containers/ServicesStatus/ServicesStatusSlice'
import carbonOffsets from '@/containers/CarbonOffsetManagement/CarbonOffsetsSlice'
import officesManagement from '@/containers/OfficesManagement/OfficesManagementSlice'
import assistanceProducts from '@/containers/AssistanceProductsManagement/AssistanceSlice'
import monConseillerPersoProducts from '@/containers/MonConseillerPersoProductsManagement/MonConseillerPersoSlice'
import dashboard from '@/containers/DashboardPage/DashboardSlice'
import subscriptionForm from '@/containers/SubscriptionFormPage/SubscriptionFormSlice'
import subscriptionFormConfiguration from '@/containers/SubscriptionFormPage/SubscriptionFormConfigurationSlice'
import formV2 from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import clientCallbacks from '@/containers/ClientCallbacksPage/ClientCallbacksSlice'
import additionalProductsTools from '@/containers/DevTools/additionalProductsToolsSlice'
import searchContacts from '@/containers/ContactSearchPage/searchContactsSlice'

const appReducer = combineReducers({
  auth,
  pageConfiguration,
  usersManagement,
  servicesStatus,
  carbonOffsets,
  officesManagement,
  assistanceProducts,
  monConseillerPersoProducts,
  dashboard,
  subscriptionForm,
  subscriptionFormConfiguration,
  formV2,
  clientCallbacks,
  additionalProductsTools,
  searchContacts,
})

export type RootState = ReturnType<typeof appReducer>

export const rootReducer = (state: ReturnType<typeof appReducer>, action: any) => appReducer(state, action)
